module.exports = __webpack_public_path__ + "img/delete.d6f61d32.svg";